import { HttpErrorResponse } from "@angular/common/http";

export function isClientError(error: HttpErrorResponse) {
  if (error.status >= 400 && error.status < 500) {
    return true;
  }

  return false;
}
